<template>
  <div class="bgFrame">
    <div :class="boxClass" style="z-index:500;">
            <img src="../../assets/home_banner4.png" class="bgImg" />
        </div>
    <div class="boxs" :style="'background-image: url(' + pointImg + ');'"></div>
    <div class="textFrame">
      <div class="textSubFrame">
        <div class="textsSubFrame">
          <div :class="textSubFrames">
            <div class="textTitleFrame">
            <div class="textTitle">聯絡我們</div>
            <div style="margin-left: 25px">
            <div style="position: relative;margin-top: 10px;width: 97px; height: 67px;display: flex;justify-content: center;align-items: center;">
              <img
                src="../../assets/btn_crm.png"
                style="position:absolute;top:0px;left: 0px;width: 97px; height: 67px"
              />
              <div class="alertText">在線客服</div>
            </div>
            </div>
          </div>
          <div style="width: 100%; margin-top: 7px;"></div>
          <img src="../../assets/home_text_eng4.png" class="textImg" />
          </div>
          <div class="shareFrame" style="display: none">
            <img
              v-for="(item, index) in serviceList"
              :key="index"
              @click="shareControl(index)"
              :src="item.src"
              class="shareLogo"
            />
          </div>
          <!-- <div style="width:100%;margin-top: 5.2%;"></div>
                <div style="width:calc(100% / 325 * 158);height:2px;background: #FFFFFF;opacity: 0.2;"></div> -->
          <div style="width: 100%; margin-top: 119px;"></div>
          <div :class="textSubFramess">
            <div class="addressTitle">地址</div>
            <div style="width: 100%; margin-top: 16px;"></div>
            <div class="addressContent">香港灣仔港灣道26號華潤大廈39樓</div>
            <div style="width: 100%; margin-top: 51px;"></div>
            <div class="addressTitle">電郵地址</div>
            <div style="width: 100%; margin-top: 16px;"></div>
            <div class="mailContent">cre_innumatch_zy@cre.com.hk</div>
          </div>
        </div>
      </div>
      <div
        class="textSubFrame"
        style="flex-grow: 1; justify-content: right; right: 0px; width: 50%"
      >
        <el-form
          :class="textSubFramesss"
          :rules="rules"
          label-position="top"
          ref="formRef"
          :model="dynamicValidateForm"
          label-width="120px"
          style="width: 100%"
        >
          <el-form-item id="name" prop="name" label="聯繫人姓名/暱稱">
            <el-input
              id="input2"
              v-model="dynamicValidateForm.name"
              placeholder="聯繫人姓名/暱稱"
            />
          </el-form-item>
          <el-form-item id="mail" prop="email" label="電郵">
            <el-input
              id="input2"
              v-model="dynamicValidateForm.email"
              placeholder="電郵"
            />
          </el-form-item>
          <el-form-item id="content" prop="content" label="具體內容">
            <el-input
              id="input3"
              v-model="dynamicValidateForm.content"
              type="textarea"
              resize="none"
              placeholder="具體內容"
            />
          </el-form-item>
          <el-form-item>
            <el-button
              round
              @mouseout="outMouse"
              @mouseover="overMouse"
              :id="BtnId"
              class="homeSendBtns"
              size="large"
              @click="submitForm"
              >送出</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { addOpinion } from "../../api/index";
import { ElMessage } from "element-plus";

export default {
  name: "App",
  components: {},
  setup() {
    onMounted(() => {});
    const serviceList = ref([
      { src: require("../../assets/facebook_hover.png"), link: "" },
      { src: require("../../assets/instagram_hover.png"), link: "" },
      { src: require("../../assets/youtube_hover.png"), link: "" },
      { src: require("../../assets/whatsapp_hover.png"), link: "" },
      { src: require("../../assets/wechat_hover.png"), link: "" },
      { src: require("../../assets/tiktok_hover.png"), link: "" },
    ]);
    const shareControl = (index) => {
      window.location.href = serviceList.value[index].link;
    };

    const formRef = ref(null);
    const dynamicValidateForm = ref({
      name: "",
      email: "",
      content: "",
    });

    const validateMail = (value) => {
      if (value === "") {
        return true;
      } else {
        // eslint-disable-next-line no-useless-escape
        if (/^[\w\.-]+@[a-z0-9\-]+(\.[a-z]{2,6}){1,3}$/i.test(value) === false) {
          return false;
        } else {
          return true;
        }
      }
    };
    const rules = {};

    const submitForm = () => {
      formRef.value.validate((valid) => {
        if (valid) {
          if (
            dynamicValidateForm.value.email == "" ||
            validateMail(dynamicValidateForm.value.email) == false
          ) {
            ElMessage.error("請輸入正確電郵");
            return;
          }
          if (dynamicValidateForm.value.name == "") {
            ElMessage.error("請輸入姓名/暱稱");
            return;
          }
          if (dynamicValidateForm.value.content == "") {
            ElMessage.error("請輸入具體內容");
            return;
          }
          addOpinion({
            name: dynamicValidateForm.value.name,
            email: dynamicValidateForm.value.email,
            content: dynamicValidateForm.value.content,
          }).then((res) => {
            if (res.errCode === 200) {
              ElMessage.success("意見回饋成功，請等待客服與您聯系");
              dynamicValidateForm.value = { name: "", email: "", content: "" };
            } else {
              ElMessage.error(res.data.msg);
            }
          });
        } else {
          return false;
        }
      });
    };

    const BtnId = ref("homeSendBtn");
    const outMouse = () => {
      BtnId.value = "homeSendBtn";
    };
    const overMouse = () => {
      BtnId.value = "homeSendB";
    };

    const startAnime = ref(false)
    let boxClass = ref('box_normal')
    let textSubFrames = ref('start_aaa')
    let textSubFramess = ref('start_bbb')
    let textSubFramesss = ref('start_ccc')
    const changeAnime = (show) =>{
      startAnime.value = show
      if (startAnime.value == false) {
        boxClass.value = 'box_normal'
        textSubFrames.value = 'start_aaa'
        textSubFramess.value = 'start_bbb'
        textSubFramesss.value = 'start_ccc'
        setTimeout(() => {
          textSubFrames.value = 'aaa'
          textSubFramess.value = 'bbb'
          textSubFramesss.value = 'ccc'
          boxClass.value = 'box_anime'
        }, 800);
      }
    }

    let pointImg = ref(require("../../assets/noise.png"));
    return {
      textSubFramesss,
      textSubFrames,
      textSubFramess,
      boxClass,
      changeAnime,
      startAnime,
      pointImg,
      BtnId,
      overMouse,
      outMouse,
      dynamicValidateForm,
      formRef,
      shareControl,
      serviceList,
      submitForm,
      rules,
      validateMail,
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes boxAnime {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.box_anime{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 1;
  animation-duration: 2s;
  animation-name: boxAnime;
}

.box_normal{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  opacity: 0;
}
.bgFrame {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(32, 45, 14);
}
.box{
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.bgImg{
  height: 100%;
  min-height: 878px;
  position: absolute;
  top: 0;
  object-fit: cover;
}

.textFrame {
  margin-left: 20%;
  margin-right: 20%;
  width: 80%;
  height: calc(100% - 218px);
  margin-bottom: 218px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 555;
}
.textSubFrame {
  display: flex;
  flex-direction: column-reverse;
  // justify-content: left;
  width: 50%;
}
.textsSubFrame {
  display: flex;
  flex-direction: column;
  justify-content: left;
}
.textTitleFrame {
  display: flex;
  opacity: 1;
}
@keyframes textSubAnime {
  from {
      transform: translate(0px, -60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.aaa {
  animation-name: textSubAnime;
  animation-duration: 1s;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.start_aaa {
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@keyframes textSubAnimes {
  from {
      transform: translate(0px, 60px);
      opacity: 0;
  }
  to {
      transform: translate(0px, 0px);
      opacity: 1;
  }
}
.bbb {
  animation-name: textSubAnimes;
  animation-duration: 1s;
  opacity: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.start_bbb {
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
@keyframes textSubAnimess {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}
.ccc {
  animation-name: textSubAnimess;
  animation-duration: 1s;
  opacity: 1;
}
.start_ccc {
  opacity: 0;
}
.textTitle {
  font-size: 65px;
  font-family: MicrosoftYaHeiLight;
  color: #ffffff;
}
.textImg {
  width: 169px;
}
.textContent {
  text-align: left;
  font-size: 10px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 16px;
}
.textTitleAlert {
  margin-left: 14px;
  width: 53px;
  height: 37px;
  background: #fdfdfe;
  opacity: 0.2;
  border-radius: 17px;
}
.alertText {
  font-size: 18px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
}
.shareFrame {
  width: 100%;
  aspect-ratio: 325 / 18;
  display: flex;
  justify-content: left;
}
.shareLogo {
  width: calc(100% / 325 * 18);
  aspect-ratio: 1 / 1;
  margin-right: 11px;
}
.addressTitle {
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  color: #ffffff;
  text-align: left;
}
.addressContent {
  font-size: 22px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
  text-align: left;
}
.mailContent {
  font-size: 22px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  color: #ffffff;
  text-align: left;
}
:deep(.el-input) {
  width: 470px;
  height: 57px;
  --el-input-focus-border-color: rgba(0, 0, 0, 0);
  --el-input-clear-hover-color: rgba(0, 0, 0, 0);
  --el-input-hover-border: rgba(0, 0, 0, 0);
  --el-input-hover-border-color: rgba(0, 0, 0, 0);
}
:deep(.el-textarea) {
  width: 470px;
  height: 151px;
  --el-input-focus-border-color: rgba(0, 0, 0, 0);
  --el-input-clear-hover-color: rgba(0, 0, 0, 0);
  --el-input-hover-border: rgba(0, 0, 0, 0);
  --el-input-hover-border-color: rgba(0, 0, 0, 0);
}
:deep(#input2) {
    width: 100%;
    height: 57px;
}
:deep(#input3) {
  width: 100%;
  height: 83px;
}
#name {
  :deep(.el-form-item__content) {
    height: 57px;
  }
}
#mail {
  :deep(.el-form-item__content) {
    height: 57px;
  }
}
:deep(.el-form--default.el-form--label-top .el-form-item .el-form-item__label) {
  display: none;
}
:deep(.el-input__wrapper) {
  border-radius: 8px !important;
  height: 57px;
  font-size: 18px !important;
  box-shadow: none;
}
:deep(.el-textarea__inner) {
  font-size: 18px !important;
  border-radius: 8px !important;
  box-shadow: none;
  height: 151px !important;
}

@keyframes hoverAmine {
  from {
    background: white;
    color: black;
    border: 1px solid white;
  }
  to {
    background: #6b834b;
    color: white;
    border: 1px solid #6b834b;
  }
}
.homeSendBtns:hover {
  background: #6b834b;
  color: white;
  border: 1px solid #6b834b;
  animation-name: hoverAmine;
  animation-duration: 0.3s;
}
#homeSendBtn {
  width: 470px;
  height: 57px;
  border-radius: 33px !important;
  :deep(span) {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #000000 !important;
  }
}

#homeSendB {
  width: 470px;
  height: 57px;
  border-radius: 33px !important;
  :deep(span) {
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: white;
  }
}

@keyframes pointAnime {
  0% {
    transform: translate3d(0, 9px, 0);
  }
  10% {
    transform: translate3d(-1px, -4px, 0);
  }
  20% {
    transform: translate3d(-8px, 2px, 0);
  }
  30% {
    transform: translate3d(-9px, -9px, 0);
  }
  40% {
    transform: translate3d(2px, 7px, 0);
  }
  50% {
    transform: translate3d(9px, -4px, 0);
  }
  60% {
    transform: translate3d(2px, 6px, 0);
  }
  70% {
    transform: translate3d(7px, -8px, 0);
  }
  80% {
    transform: translate3d(-9px, 1px, 0);
  }
  90% {
    transform: translate3d(6px, -5px, 0);
  }
  to {
    transform: translate3d(-7px, 0, 0);
  }
}
.boxs {
  overflow: hidden;
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 501;
  position: absolute;
  background-position: 50%;
  animation: pointAnime 1.3s steps(2) infinite;
}
</style>
